import { createSlice } from '@reduxjs/toolkit';
import { login, logout, forgotPassword, resetPassword } from '../thunks/authThunks';
import { reset } from '../actions/resetActions';

const initialState = {
  userData: null,
  isAuthenticated: false,
  officeOnlyMode: false,
  loading: false,
  error: null,
  success : null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSuccess : (state, action) => {
      state.success = action.payload
    },
    setOfficeOnlyMode : (state, action) => {
      state.officeOnlyMode = Boolean(action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(reset, () => initialState)
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.userData = action.payload;
        state.officeOnlyMode = Boolean(action.payload?.officeOnlyMode);
        state.error = null;
        state.success = action.payload.status
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = null;
      })
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;

      })
      .addCase(logout.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.userData = null;
        state.error = null;
        state.success = action.payload.message
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = null;
      })
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const authAction = authSlice.actions;
export const authReducer = authSlice.reducer;